/**
 * @typedef {typeof globalThis} GlobalType
 */

const globals = /** @type {GlobalType} */ ((typeof window !== 'undefined') ? window : (typeof global !== 'undefined') ? global : this);

export { globals };

export default globals;
